import cn from 'classnames';
import { useByoDataContext } from "@pages/Byo/ByoContext";
import { ByoAnalyticType, ByoValueType } from "@models/Byo";

const TableTypeToggle = () => {
    const {
        activeValueType,
        setActiveValueType,
        activeAnalyticsType,
    } = useByoDataContext();

    const isDisabled = activeAnalyticsType === ByoAnalyticType.Price || activeAnalyticsType === ByoAnalyticType.Count;

    const classListBtn1 = cn('ByoTable__header-btn', {
        'is-active': activeValueType === ByoValueType.Pct,
        'is-disabled': isDisabled,
    });

    const classListBtn2 = cn('ByoTable__header-btn', {
        'is-active': activeValueType === ByoValueType.Count,
        'is-disabled': isDisabled,
    });

    return (
        <>
            <button
                className={classListBtn1}
                onClick={() => setActiveValueType(ByoValueType.Pct)}
            >
                %
            </button>
            <button
                className={classListBtn2}
                onClick={() => setActiveValueType(ByoValueType.Count)}
            >
                #
            </button>
        </>
    );
};

export default TableTypeToggle;
